
import { Globe, Check } from "lucide-react";
import { Button } from "./ui/button";
import {
    DropdownMenu,
    DropdownMenuTrigger,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuSub,
    DropdownMenuSubTrigger,
    DropdownMenuSubContent,
} from "./ui/dropdown-menu";
import { languages } from "../lib/languages";

import { useLanguage } from "../context/LanguageContext";

export function LanguageSwitcher() {
    const { currentLanguage, changeLanguage } = useLanguage();

    const handleSelect = (lang) => {
        changeLanguage(lang);
    };

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button variant="ghost" size="icon" className="rounded-full w-9 h-9 text-slate-500 hover:text-slate-700 hover:bg-slate-100" title="Change Language">
                    <Globe className="w-5 h-5" />
                    <span className="sr-only">Switch Language</span>
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-56 max-h-[80vh] overflow-y-auto">
                {languages.map((lang) => {
                    if (lang.dialects) {
                        return (
                            <DropdownMenuSub key={lang.code}>
                                <DropdownMenuSubTrigger className="cursor-pointer">
                                    <div className="flex items-center gap-2 w-full">
                                        <span>{lang.name}</span>
                                        {/* Show check if any dialect is selected */}
                                        {currentLanguage && lang.dialects.some(d => d.code === currentLanguage.code) && (
                                            <span className="w-1.5 h-1.5 rounded-full bg-slate-400 ml-2" />
                                        )}
                                    </div>
                                </DropdownMenuSubTrigger>
                                <DropdownMenuSubContent>
                                    {lang.dialects.map((dialect) => (
                                        <DropdownMenuItem
                                            key={dialect.code}
                                            onClick={() => handleSelect(dialect)}
                                            className="cursor-pointer"
                                        >
                                            <span className={currentLanguage?.code === dialect.code ? "font-medium" : ""}>
                                                {dialect.name}
                                            </span>
                                            {currentLanguage?.code === dialect.code && <Check className="w-4 h-4 ml-auto" />}
                                        </DropdownMenuItem>
                                    ))}
                                </DropdownMenuSubContent>
                            </DropdownMenuSub>
                        )
                    }
                    return (
                        <DropdownMenuItem
                            key={lang.code}
                            onClick={() => handleSelect(lang)}
                            className="cursor-pointer"
                        >
                            <span className={currentLanguage?.code === lang.code ? "font-medium" : ""}>
                                {lang.name}
                            </span>
                            {currentLanguage?.code === lang.code && <Check className="w-4 h-4 ml-auto" />}
                        </DropdownMenuItem>
                    )
                })}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
